import { render, staticRenderFns } from "./DevInfo.vue?vue&type=template&id=3b51b464&scoped=true"
import script from "./DevInfo.vue?vue&type=script&lang=js"
export * from "./DevInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51b464",
  null
  
)

export default component.exports